<div id="manange-videos-container">
    <div class="row " *ngIf="hasPermission">
        <span class="float-right ml-auto" style="margin-right: 85px;">
            <button class="ml-2 btn btn-browse" type="button" (click)="addVideos()">Add Videos</button>
        </span>
    </div>
    <div class="col-md-12 mt-3" *ngIf="videoDataSource && videoDataSource.data.length >0">
        <mat-form-field class="float-right">
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
        </mat-form-field>
        <!-- Material Table -->
        <table aria-describedby="videos" aria-labelledby="videos" mat-table [dataSource]="videoDataSource" matSort class="col-md-12 mat-elevation-z8">

            <ng-container matColumnDef="videos.videoGroup">
                <th id="video-grp" class="video-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Video Group </th>
                <td mat-cell *matCellDef="let element"> {{element.videos.videoGroup}} </td>
            </ng-container>

            <ng-container matColumnDef="videos.videoName">
                <th id="video-name" class="video-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Video Name </th>
                <td mat-cell *matCellDef="let element">
                    <a class="video-name-list-item" [href]='element.videos.videoUrl' target="_blank">{{element.videos.videoName}}
                            <span class="fa fa-external-link"></span>
                    </a>
                </td>
            </ng-container>

            <ng-container matColumnDef="featureType">
                <th id="video-type" class="video-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Content Type </th>
                <td mat-cell *matCellDef="let element"> {{element.featureType | capitalizeStr}} </td>
            </ng-container>

            <ng-container matColumnDef="uploadedTime">
                <th id="video-upload-time" class="video-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.Uploaded_Date_Time" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.uploadedTime| date:'MM/dd/yy, hh:mm a'}} </td>
            </ng-container>

            <ng-container matColumnDef="uploadedBy">
                <th id="video-upload-time" class="video-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.Uploaded_by" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.uploadedBy }} </td>
            </ng-container>

            <ng-container matColumnDef="edit">
                <th id="video-action-edit" class="video-header-card" mat-header-cell *matHeaderCellDef>{{ "Label.Edit" | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <span class="action-control col-md-1">
                        <a matTooltip="Click to Edit" class="action-control-edit" (click)="editVideo(row);">
                            <img alt="Edit" [src]="commonService.commonFiles['edit']">
                        </a>
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th id="video-action-delete" class="video-header-card" mat-header-cell *matHeaderCellDef>{{ "Label.Delete" | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <span class="action-control col-md-1">
                        <a matTooltip="Click to Delete" class="action-control-delete" (click)="deleteVideo(row);">
                            <img alt="Delete" [src]="commonService.commonFiles['delete']">
                        </a>
                    </span>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10,20]" showFirstLastButtons></mat-paginator>
    </div>
</div>